<div class="modal-body flex flex-col box-border">
  <header class="modal-header grow-0">
    <div class="flex justify-between items-end gap-4">
      <h2 *ngIf="data?.title" class="modal-headline grow" i18n [innerHTML]="data.title"></h2>
      <button mat-icon-button [mat-dialog-close]="false" class="button-close ml-auto grow-0">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </header>

  <div class="modal-main flex justify-between items-start grow">
    <div class="flex flex-col">
      <div *ngIf="data?.message && !messageList.length">{{ data.message }}</div>
      <div *ngIf="data?.message && messageList.length">
        <p *ngFor="let msg of messageList" [innerHTML]="msg" class="mb-2" [ngClass]="data.messageListCssStyle"></p>
      </div>
    </div>
  </div>

  <footer class="modal-footer !flex !flex-col grow-0">
    <div *ngIf="data.downloadReport" class="flex w-full justify-end mb-4">
      <a [href]="fileUrl" download="report.txt" class="button-primary" i18n>Download report</a>
    </div>

    <div class="flex flex-row-reverse justify-between items-center gap-4" [ngClass]="data.confirmCaptionCssStyle">
      <button mat-flat-button [mat-dialog-close]="true" cdkFocusInitial class="button-primary" *ngIf="data.confirmCaption">
        <mat-icon class="material-icons-outlined absolute" *ngIf="data.confirmCaptionIcon">{{ data.confirmCaptionIcon }}</mat-icon>
        {{ data.confirmCaption }}
      </button>

      <button mat-flat-button [mat-dialog-close]="false" class="button-secondary" *ngIf="data.cancelCaption">
        {{ data.cancelCaption }}
      </button>
    </div>
  </footer>
</div>
